import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=287e60cf&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=287e60cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e60cf",
  null
  
)

export default component.exports